/**
 * Created by vladislav on 13.11.2020
 */

const FlyingAdView = cc.Node.extend({
    ctor: function () {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.FlyingAdView;

        this.setContentSize2(styles);
        this.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });
        this.createAnimation();

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.setScale(styles.mobile.scale);
            this.baseScale = this.scale;
        }

        cleverapps.UI.applyHover(this, {
            filter: this.isClickAvailable.bind(this),

            onMouseOver: function () {
                this.animation.setSkin(`${cleverapps.flyingAd.getSkin()}_hover`);
            }.bind(this),

            onMouseOut: function () {
                this.animation.setSkin(`${cleverapps.flyingAd.getSkin()}_normal`);
            }.bind(this)
        });

        cleverapps.UI.onClick(this, cleverapps.flyingAd.onClick.bind(cleverapps.flyingAd), {
            filter: this.isClickAvailable.bind(this)
        });

        this.setLocalZOrder(16);

        if (cleverapps.flyingAd.enabled) {
            this.enable();
        } else {
            this.disable();
        }

        cleverapps.flyingAd.on("disable", this.createListener(this.disable.bind(this)));
        cleverapps.flyingAd.on("enable", this.createListener(this.enable.bind(this)));
        cleverapps.flyingAd.on("disappear", this.createListener(this.disappear.bind(this)));
        cleverapps.flyingAd.on("toggle", this.createListener(this.toggle.bind(this)));
        cleverapps.flyingAd.on("changeType", this.createListener(this.changeType.bind(this)));
    },

    isClickAvailable: function () {
        return this.isVisible() && cleverapps.flyingAd.isClickAvailable();
    },

    onResize: function () {
        if (cleverapps.flyingAd.enabled) {
            this.stopAllActions();
            this.runMoveAnimation();
        }
    },

    createAnimation: function () {
        const styles = cleverapps.styles.FlyingAdView;

        this.animation = new cleverapps.Spine(bundles.flying_ad.jsons.flying_ad_json);
        this.addChild(this.animation);
        this.animation.setAlignment(styles.animation);
    },

    changeType: function () {
        this.animation.setSkin(`${cleverapps.flyingAd.getSkin()}_normal`);
    },

    toggle: function (visible) {
        if (this.isVisible() === visible) {
            return;
        }

        this.setVisible(visible);

        if (visible) {
            this.animation.runAction(new cc.RepeatForever(new cc.Sequence(
                cleverapps.effects.fireAction("flying_ad.fly"),
                new cc.DelayTime(3.8)
            )));
        } else {
            this.animation.stopAllActions();
        }
    },

    disappear: function () {
        this.stopAllActions();
        this.animation.setAnimation(0, "application", false);
        this.animation.setCompleteListener(() => {
            this.animation.setCompleteListener();
            this.toggle(false);
        });
    },

    runMoveAnimation: function () {
        this._runMoveAnimation(1);
    },

    _runMoveAnimation: function (dir) {
        const scene = cleverapps.Scenes.GetRunningScene();

        const styles = cleverapps.styles.FlyingAdView;

        const isVertical = cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain
            && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
        let point;
        const xBorderOffset = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? styles.mobile.xBorderOffset : styles.xBorderOffset;
        const yOffsetBottom = styles.yOffsetBottom;
        const yOffsetTop = styles.yOffsetTop;
        if (dir > 0) {
            if (isVertical) {
                point = cc.p(scene.width / 2, scene.height - yOffsetTop);
            } else {
                point = cc.p(scene.width - xBorderOffset, this.y);
            }
        } else if (isVertical) {
            point = cc.p(scene.width / 2, yOffsetBottom);
        } else {
            point = cc.p(xBorderOffset, this.y);
        }

        const speed = cleverapps.styles.FlyingAdView.speed;
        const time = cc.pDistance(this.getPosition(), point) / speed;
        const times = Math.round(time / 7);
        let flyAnimation = new cc.MoveBy(time, cc.p(point.x - this.x, point.y - this.y));

        let dx = 0, dy = 0;
        if (isVertical) {
            dx = cleverapps.styles.FlyingAdView.animation.dx;
        } else {
            dy = cleverapps.styles.FlyingAdView.animation.dy;
        }
        if (times > 0) {
            const yflyes = [];
            const oneFlyTime = time / times / 2;
            for (let i = 0; i < times; i++) {
                yflyes.push(new cc.MoveBy(oneFlyTime / 2, cc.p(dx / 2, dy / 2)));
                yflyes.push(new cc.MoveBy(oneFlyTime, cc.p(-dx, -dy)));
                yflyes.push(new cc.MoveBy(oneFlyTime / 2, cc.p(dx / 2, dy / 2)));
            }
            flyAnimation = new cc.Spawn(
                flyAnimation,
                new cc.Sequence(yflyes)
            );
        }

        this.runAction(new cc.Sequence(
            flyAnimation,
            new cc.CallFunc(() => {
                this._runMoveAnimation(-dir);
            })
        ));
    },

    enable: function () {
        this.stopAllActions();
        this.animation.setCompleteListener();
        this.toggle(!cleverapps.focusManager.isFocused());
        this.animation.setAnimationAndIdleAfter("appearance", "idle");
        this.runMoveAnimation();
        cleverapps.effects.fire("flying_ad.show");
    },

    disable: function () {
        this.stopAllActions();
        this.toggle(false);
    }
});

cleverapps.styles.FlyingAdView = {
    width: 200,
    height: 200,

    mobile: {
        xBorderOffset: 160,
        scale: 0.8
    },

    animation: {
        x: { align: "center" },
        y: { align: "center", dy: -30 },
        dy: 60,
        dx: 200
    },

    xBorderOffset: 300,
    yOffsetBottom: 500,
    yOffsetTop: 150,
    speed: 80
};